import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { SuperComponent } from '../../../inside.super';
import { VertraegeService } from '../../../../providers.module/vertraege.service';

export class SubPage {
    static OBLIGO = 'OBLIGO';
    static BUERGSCHAFT_CREATE = 'BUERGSCHAFT_CREATE';
    static SINGLE_BUERGSCHEIN = 'SINGLE_BUERGSCHEIN';
    static BUERGSCHEIN_LIST = 'BUERGSCHEIN_LIST';
}

@Component({
    selector: 'buergschaften',
    templateUrl: './buergschaften.component.html',
    styleUrls: ['../../../commonless/content.less', '../../../commonless/buergschaften.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuergschaftenComponent extends SuperComponent implements OnInit, OnDestroy {

    constructor(
        private readonly activatedRoute: ActivatedRoute,
        private readonly vertraegeService: VertraegeService
    ) {
        super();
    }

    vsnr: string = null;
    vsnrFormatiert: string = null;
    buergscheinId: string = null;

    obligo = false;

    subPage: string = SubPage.BUERGSCHEIN_LIST;
    private sub: any;
    private p: any;

    ngOnInit() {
        this.sub = this.activatedRoute.params.subscribe(params => {
            const tmp = params['subPage'];
            switch (tmp) {
                case 'obligo':
                    this.subPage = SubPage.OBLIGO;
                    break;
                case 'create-buergschein':
                    this.subPage = SubPage.BUERGSCHAFT_CREATE;
                    break;
                case null:
                case undefined:
                    this.subPage = SubPage.BUERGSCHEIN_LIST;
                    break;
                default: // real VSNR
                    this.subPage = SubPage.SINGLE_BUERGSCHEIN;

                    this.vertraegeService.getVertrag(tmp).subscribe(vertragData => {
                        this.vsnrFormatiert = vertragData.vertragHandle.vsnrFormatiert;
                        this.vsnr = vertragData.vertragHandle.vsnrNumerisch;
                    });
            }
        });

        this.p = this.activatedRoute.queryParams.subscribe((params: Params) => {
            const buergscheinId = params['param'];
            if (buergscheinId) {
                this.buergscheinId = buergscheinId;
            } else {
                this.buergscheinId = null;
            }
        });
    }

    ngOnDestroy() {
        this.vsnrFormatiert = null;
        this.buergscheinId = null;
        if (this.sub) {
            this.sub.unsubscribe();
        }
        if (this.p) {
            this.p.unsubscribe();
        }
    }

}
